<template>
  <button class="patient-enrollment_button" :class="classlist" :type="type">
    <img
      v-show="loading"
      class="loader"
      src="../assets/images/loading-circle.svg"
      alt=""
    />
    <span v-show="!loading">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    type: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "primary"
    },
    size: String,
    color: String,
    block: Boolean,
    display: Boolean,
    classes: {
      type: String,
      default: ""
    },
    loading: Boolean
  },
  computed: {
    classlist() {
      let classes = "vcore_btn " + this.classes;
      if (this.variant.toLowerCase() === "secondary") {
        classes += " vcore_btn--secondary";
      } else if (this.variant.toLowerCase() === "flat") {
        classes += " vcore_btn--flat";
      } else {
        classes += " vcore_btn--primary";
      }

      if (this.size === "large") {
        classes += " vcore_btn--lg";
      } else if (this.size === "small") {
        classes += " vcore_btn--sm";
      } else {
        classes += " vcore_btn--md";
      }

      if (this.color === "blue") {
        classes += " vcore_btn--blue";
      } else if (this.color === "red") {
        classes += " vcore_btn--red";
      } else {
        classes += " vcore_btn--green";
      }

      if(this.display) {
        classes += " vcore_btn--none";
      }

      if (this.block) {
        classes += " vcore_btn--block";
      }
      if (this.loading) {
        classes += " loading";
      }

      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.vcore_btn.patient-enrollment_button {
  border-radius: 4px !important;

  &:hover {
    &.hover_blue {
      background-color: darken($color_dark-blue, 12%) !important;
    }
  }

  &:focus {
    &.focus_blue {
      background-color: darken($color_dark-blue, 12%) !important;
    }
  }
}

.loader {
  display: inline-block;
  height: 27px;
  width: 27px;
  margin-top: 8px;
  outline: none;
  outline-style: none;
  box-shadow: none;
  border-color: transparent;
  animation: rotating 500ms linear infinite;
}

.vcore_btn--lg > .loader {
  margin-top: 10px;
}

.vcore_btn--sm > .loader {
  margin-top: 6px;
}

.vcore_btn--none {
  display:none !important;
}

.vcore_btn.vcore_btn--primary.vcore_btn--lg{
  font-size: 18.66px;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
